export default "__VITE_ASSET__DA_SbLaT__"